import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import Navigation from './components/Navigation';
import HomePage from './pages/Home';
import ShopPage from './pages/Shop';
import ShopDetail from './pages/ShopDetail';
import ProfilePage from './pages/Profile';
import CheckoutPage from './pages/Checkout';
import ShopCartPage from './pages/ShopCart';
import ProductDetail from './pages/ProductDetail';
import './i18n';
import { AuthProvider } from './contexts/AuthContext';
import Login from './components/auth/Login';
import Signup from './components/auth/Signup';
import PrivateRoute from './components/auth/PrivateRoute';
import RoleRoute from './components/auth/RoleRoute';
import Dashboard from './pages/Dashboard';
import { USER_ROLES } from './firebase/config';
import EditProfile from './pages/Profile/EditProfile';
import { CartProvider } from './contexts/CartContext';
import Wishlist from './pages/Profile/Wishlist';
import CustomerOrders from './pages/Profile/Orders';
import CustomerOrderDetail from './pages/Profile/OrderDetail';
import SellerPage from './pages/Seller';
import ShopSettings from './pages/Seller/ShopSettings';
import Products from './pages/Seller/Products';
import Orders from './pages/Seller/Orders';
import OrderDetail from './pages/Seller/OrderDetail';
import Shipping from './pages/Seller/Shipping';
import Payments from './pages/Seller/Payments';
import PaymentPage from './pages/Payment';

function App() {
  return (
    <Router>
      <AuthProvider>
        <CartProvider>
          <div className="app-container min-vh-100">
            <Container className="py-3 px-3">
              <Routes>
                {/* Rotte pubbliche */}
                <Route path="/" element={<HomePage />} />
                <Route path="/shops" element={<ShopPage />} />
                <Route path="/:shopName" element={<ShopDetail />} />
                <Route path="/:shopName/product/:productId" element={<ProductDetail />} />
                <Route path="/checkout" element={<CheckoutPage />} />
                <Route path="/checkout/:shopName" element={<ShopCartPage />} />
                <Route path="/payment/:shopName/:orderId" element={<PaymentPage />} />
                <Route path="/profile" element={<ProfilePage />} />
                <Route path="/login" element={<Login />} />
                <Route path="/signup" element={<Signup />} />

                {/* Rotte protette per clienti */}
                <Route
                  path="/profile"
                  element={
                    <RoleRoute allowedRoles={[USER_ROLES.CUSTOMER]}>
                      <ProfilePage />
                    </RoleRoute>
                  }
                />
                <Route
                  path="/checkout"
                  element={
                    <RoleRoute allowedRoles={[USER_ROLES.CUSTOMER]}>
                      <CheckoutPage />
                    </RoleRoute>
                  }
                />
                <Route
                  path="/checkout/:shopName"
                  element={
                    <RoleRoute allowedRoles={[USER_ROLES.CUSTOMER]}>
                      <ShopCartPage />
                    </RoleRoute>
                  }
                />
                <Route
                  path="/payment/:shopName/:orderId"
                  element={
                    <RoleRoute allowedRoles={[USER_ROLES.CUSTOMER]}>
                      <PaymentPage />
                    </RoleRoute>
                  }
                />

                {/* Rotte protette per venditori */}
                <Route
                  path="/seller/dashboard"
                  element={
                    <RoleRoute allowedRoles={[USER_ROLES.SELLER]}>
                      <Dashboard />
                    </RoleRoute>
                  }
                />
                <Route
                  path="/seller/settings"
                  element={
                    <RoleRoute allowedRoles={[USER_ROLES.SELLER]}>
                      <ShopSettings />
                    </RoleRoute>
                  }
                />
                <Route
                  path="/seller/products"
                  element={
                    <RoleRoute allowedRoles={[USER_ROLES.SELLER]}>
                      <Products />
                    </RoleRoute>
                  }
                />
                <Route
                  path="/seller/orders"
                  element={
                    <RoleRoute allowedRoles={[USER_ROLES.SELLER]}>
                      <Orders />
                    </RoleRoute>
                  }
                />
                <Route
                  path="/seller/orders/:orderId"
                  element={
                    <RoleRoute allowedRoles={[USER_ROLES.SELLER]}>
                      <OrderDetail />
                    </RoleRoute>
                  }
                />
                <Route
                  path="/seller/shipping"
                  element={
                    <RoleRoute allowedRoles={[USER_ROLES.SELLER]}>
                      <Shipping />
                    </RoleRoute>
                  }
                />
                <Route
                  path="/seller/payments"
                  element={
                    <RoleRoute allowedRoles={[USER_ROLES.SELLER]}>
                      <Payments />
                    </RoleRoute>
                  }
                />

                {/* Rotte protette per admin */}
                <Route
                  path="/admin/dashboard"
                  element={
                    <RoleRoute allowedRoles={[USER_ROLES.ADMIN]}>
                      <Dashboard />
                    </RoleRoute>
                  }
                />

                <Route path="/profile/edit" element={<EditProfile />} />
                <Route path="/profile/wishlist" element={<Wishlist />} />
                <Route path="/profile/orders" element={<CustomerOrders />} />
                <Route path="/profile/orders/:shopId/:orderId" element={<CustomerOrderDetail />} />
                <Route path="/seller" element={<SellerPage />} />

                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </Container>
            <Navigation />
          </div>
        </CartProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
